// What the assistant's cards say about this module, in the four languages:
// `customerPortal.assistant.*`. The backend sends the key and the English text
// (section 16, backend/assistant.js); the card says it in the reader's language.
// Kept apart from index.js because it is a contract with that file, not copy of
// a screen: a key changed here is changed there.

export default {
  es: {
    value: { yes: 'Sí', no: 'No' },
    publish: {
      summary: {
        unknown: 'Publicar un registro en el portal de cliente',
        plain: 'Publicar {what} para {customer} (versión {version})',
        decide: 'Publicar {what} para {customer} y pedirle que decida (versión {version})',
      },
      action: 'Publicar en el portal de cliente',
      field: { record: 'Registro', customer: 'Cliente', version: 'Versión', decision: 'Pedirle que decida' },
      where: 'Publicación',
      after: {
        plain: '{customer} lo verá en su portal',
        decide: '{customer} lo verá y se le pedirá que lo apruebe',
      },
      outcome: 'Publicado para {customer}: {what}',
    },
    reply: {
      summary: {
        customer: 'Enviar al cliente, en {what}: «{text}»',
        internal: 'Nota interna (el cliente no la ve), en {what}: «{text}»',
      },
      action: { customer: 'Contestar al cliente', internal: 'Añadir una nota interna' },
      field: { visibility: 'Quién lo lee', request: 'Solicitud', customer: 'Cliente', body: 'Mensaje' },
      value: { customer: 'El cliente', internal: 'Solo la empresa' },
      where: 'Solicitud',
      after: {
        customer: 'El cliente lo lee y la solicitud queda esperando su respuesta',
        internal: 'El cliente no lo verá',
      },
      outcome: { customer: 'Respuesta enviada al cliente', internal: 'Nota interna añadida' },
    },
  },
  ca: {
    value: { yes: 'Sí', no: 'No' },
    publish: {
      summary: {
        unknown: 'Publicar un registre al portal de client',
        plain: 'Publicar {what} per a {customer} (versió {version})',
        decide: 'Publicar {what} per a {customer} i demanar-li que decideixi (versió {version})',
      },
      action: 'Publicar al portal de client',
      field: { record: 'Registre', customer: 'Client', version: 'Versió', decision: 'Demanar-li que decideixi' },
      where: 'Publicació',
      after: {
        plain: '{customer} ho veurà al seu portal',
        decide: '{customer} ho veurà i se li demanarà que ho aprovi',
      },
      outcome: 'Publicat per a {customer}: {what}',
    },
    reply: {
      summary: {
        customer: 'Enviar al client, a {what}: «{text}»',
        internal: 'Nota interna (el client no la veu), a {what}: «{text}»',
      },
      action: { customer: 'Respondre al client', internal: 'Afegir una nota interna' },
      field: { visibility: 'Qui ho llegeix', request: 'Sol·licitud', customer: 'Client', body: 'Missatge' },
      value: { customer: 'El client', internal: 'Només l’empresa' },
      where: 'Sol·licitud',
      after: {
        customer: 'El client ho llegeix i la sol·licitud queda esperant la seva resposta',
        internal: 'El client no ho veurà',
      },
      outcome: { customer: 'Resposta enviada al client', internal: 'Nota interna afegida' },
    },
  },
  en: {
    value: { yes: 'Yes', no: 'No' },
    publish: {
      summary: {
        unknown: 'Publish a record to the customer portal',
        plain: 'Publish {what} to {customer} (version {version})',
        decide: 'Publish {what} to {customer} and ask them to decide on it (version {version})',
      },
      action: 'Publish to the customer portal',
      field: { record: 'Record', customer: 'Customer', version: 'Version', decision: 'Ask them to decide' },
      where: 'Publication',
      after: {
        plain: '{customer} will see it in their portal',
        decide: '{customer} will see it and be asked to approve it',
      },
      outcome: 'Published to {customer}: {what}',
    },
    reply: {
      summary: {
        customer: 'Send to the customer, on {what}: “{text}”',
        internal: 'Internal note (the customer does not see it), on {what}: “{text}”',
      },
      action: { customer: 'Reply to the customer', internal: 'Add an internal note' },
      field: { visibility: 'Who reads it', request: 'Request', customer: 'Customer', body: 'Message' },
      value: { customer: 'The customer', internal: 'Only the company' },
      where: 'Request',
      after: {
        customer: 'The customer reads it, and the request waits for their answer',
        internal: 'The customer will not see it',
      },
      outcome: { customer: 'Reply sent to the customer', internal: 'Internal note added' },
    },
  },
  fr: {
    value: { yes: 'Oui', no: 'Non' },
    publish: {
      summary: {
        unknown: 'Publier un élément sur le portail client',
        plain: 'Publier {what} pour {customer} (version {version})',
        decide: 'Publier {what} pour {customer} et lui demander de décider (version {version})',
      },
      action: 'Publier sur le portail client',
      field: { record: 'Élément', customer: 'Client', version: 'Version', decision: 'Lui demander de décider' },
      where: 'Publication',
      after: {
        plain: '{customer} le verra sur son portail',
        decide: '{customer} le verra et devra l’approuver',
      },
      outcome: 'Publié pour {customer} : {what}',
    },
    reply: {
      summary: {
        customer: 'Envoyer au client, sur {what} : « {text} »',
        internal: 'Note interne (le client ne la voit pas), sur {what} : « {text} »',
      },
      action: { customer: 'Répondre au client', internal: 'Ajouter une note interne' },
      field: { visibility: 'Qui le lit', request: 'Demande', customer: 'Client', body: 'Message' },
      value: { customer: 'Le client', internal: 'Seulement l’entreprise' },
      where: 'Demande',
      after: {
        customer: 'Le client le lit, et la demande attend sa réponse',
        internal: 'Le client ne le verra pas',
      },
      outcome: { customer: 'Réponse envoyée au client', internal: 'Note interne ajoutée' },
    },
  },
}
